import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export class Notification extends Model<Schemas['notifications'], Models> {
    get createdAtDate() {
        return nullableDate(this.createdAt);
    }

    get updatedAtDate() {
        return nullableDate(this.updatedAt);
    }

    get readAtDate() {
        return nullableDate(this.readAt);
    }
}
